import { apiFetch } from '../../apiFetch'

export const postAdminAddress = async (payload) => {
  const req = await apiFetch({
    method: 'POST',
    path: '/admin/addresses/',
    payload
  })

  return await req
}
